'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggingData = undefined;
exports.setLogSender = setLogSender;
exports.setLoggingData = setLoggingData;
exports.log = log;

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _Usage = require('./VideoStore/Usage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Constructs the VI Analytics Data object from various sources of information
 * as well as some static pieces of info relevant to this implementation, and then
 * fires a log to Sumo with a string message and the total object containing
 * all the relevant informaton to log
 *
 * @providesModule Log
 * @param {String} funcName
 * @param {Object} func
 */

var url = '/Logging/LogData';
var loggingData = exports.loggingData = void 0;
var sendLog = undefined;

/**
 * Sets the log sender function. Intended for use outside hudl.com domains (i.e. Insights)
 * @param {Object} sender - method to process logs. Defaults to a post to /Logging/LogData
 */
function setLogSender(sender) {
  sendLog = sender;
}

/**
 * Safely converts a provided objects propertys that are string into pascal case.
 * @param {Object} obj - Object to convert
 *
 * @private
 * @internal
 * @returns { Object } - Pascal converted object
 */
function toPascalCase(obj) {
  var newObject = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var pascalKey = key[0].toUpperCase() + key.substring(1);
      newObject[pascalKey] = obj[key];
    }
  }

  return newObject;
}

/**
 * Safely converts a provided object into a Sumo safe string.
 * Useful for the equivalent of nested objects in a Sumo call.
 * @param {Object} obj
 *
 * @private
 * @internal
 */
function objectToSumoFormat(obj) {
  if (obj === null) {
    return null;
  }

  var pascalObject = toPascalCase(obj);
  var sumoFormatArray = Object.keys(pascalObject).map(function (key) {
    var value = pascalObject[key] || '(null)';
    if (pascalObject[key] === false) {
      value = 'false';
    }
    return key + '=' + value;
  });

  return '[' + sumoFormatArray.join(',') + ']';
}

/**
 * Default way of sending logs (post to log endpoint).
 * @param {Object} loggingParams
 *
 * @private
 * @internal
 */
function defaultSendLog(loggingParams, funcName) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url + '?' + funcName, true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.send(JSON.stringify(loggingParams));
}

function setLoggingData(loggingDataObject) {
  exports.loggingData = loggingData = loggingDataObject;
}

function log(playerId, funcName, func) {
  var players = _store2.default.storeInstance().getState().players;
  var player = playerId ? players[playerId] : players[Object.keys(players)[0]];

  if (!loggingData || !player) {
    return;
  }

  var playable = player.playables.get(player.playingIndex);

  var data = {
    app: 'Hudl',
    authUser: loggingData.authUser,
    role: loggingData.userRole,
    op: 'VideoInterface',
    videoInterface: loggingData.videoInterface + '.' + "22.5.0-master-22XX-React15Uniform3Sup.1224",
    userAgent: navigator.userAgent,
    pageURL: location.toString(),
    playerId: playerId,
    func: funcName,
    attributes: objectToSumoFormat(func),
    video: playable ? playable.videoId : 'Failed',
    clip: null,
    playlist: null,
    contentOwner: objectToSumoFormat({
      team: playable ? playable.contentTeam : 'Failed'
    }),
    contentDuration: player.durationMs,
    contentPosition: player.currentTimeMs,
    contentConsumed: (0, _Usage.getUsage)(),
    viGUID: loggingData.requestId,
    isFullscreen: player.fullscreen
  };

  var params = {
    loggerName: 'VIAnalyticsLogger',
    message: funcName,
    data: toPascalCase(data)
  };

  var send = sendLog || defaultSendLog;
  send(params, funcName);
}